import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/** Host-conditional redirects — use with canMatch instead of redirectTo on the same route. */
@Component({
    standalone: true,
    template: '',
})
export class RedirectComponent implements OnInit {
    private readonly _route = inject(ActivatedRoute);
    private readonly _router = inject(Router);

    ngOnInit(): void {
        const target = this._route.snapshot.data['redirectTo'] as string | string[] | undefined;

        if (Array.isArray(target)) {
            void this._router.navigate(target, { replaceUrl: true });
            return;
        }

        void this._router.navigateByUrl(target ?? '/dashboard', { replaceUrl: true });
    }
}
